import { colorPalette } from 'core/layouts/ui-blocks/ColorPalette';

export const selectedImageInfoStyles = {
	selectedImageInfoCont: {
		padding: '10px 8px',
		gap: '6px',
		borderRadius: '4px',
		display: 'flex',
		flexDirection: 'column',
		backgroundColor: 'colors.dark5',
		borderWidth: '1px',
		borderStyle: 'solid',
		borderColor: 'colors.dark4',
	},
	infoChip: {
		border: `1px ${colorPalette.dark3} solid`,
		backgroundColor: 'colors.dark4',
		width: 'fit-content',
		gap: '6px',
		padding: '6px',
	},
	promptDescription: {
		color: 'colors.light4',
		maxWidth: '140px',
		maxHeight: '200px',
		overflowY: 'scroll',
		lineHeight: '14px',
	},
};
